import React, { ComponentProps, ReactNode } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import {
  HealthiestFoodRoot,
  Wrapper,
  Title,
  Description1,
  TextWrapper,
} from './HealthiestFood.styles'

import healthiest1 from '../../../../../public/assets/wwfr-healthiest-1.png'
import healthiest2 from '../../../../../public/assets/wwfr-healthiest-2.png'
import Image from 'next/image'
import Trans from 'next-translate/Trans'
import { Link } from 'components/Link'

type HealthiestFoodOwnProps = ComponentProps<typeof HealthiestFoodRoot>
export type HealthiestFoodProps = HealthiestFoodOwnProps & {}

export const HealthiestFood = (_props: HealthiestFoodProps) => {
  const { t } = useTranslation()

  return (
    <HealthiestFoodRoot>
      <Wrapper>
        <Stack direction="column" gap={{ '@initial': '3', '@bp2': '9' }}>
          <Stack direction="column" gap={{ '@initial': '2', '@bp2': '3' }}>
            <Title>
              <Text
                size={{ '@initial': 'h3', '@bp2': 'h1' }}
                as="h2"
                weight="bold"
                color="primary-800"
                align={{ '@initial': 'center', '@bp2': 'left' }}
              >
                {t('why-we-feed-raw:healthiest-food.title')}
              </Text>
            </Title>
            <Text size="headline" color="primary-800" align="center">
              {t('why-we-feed-raw:healthiest-food.description-1')}
            </Text>
          </Stack>

          <div>
            <Stack
              direction={{ '@initial': 'column', '@bp2': 'row' }}
              alignItems="center"
              gap={{ '@initial': '3', '@bp2': '2' }}
            >
              <Description1
                size="headline"
                color="primary-800"
                align={{ '@initial': 'center', '@bp2': 'left' }}
              >
                {t('why-we-feed-raw:healthiest-food.description-2')}
              </Description1>
              <Image src={healthiest1} alt="" />
            </Stack>
          </div>

          <div>
            <Stack
              alignItems="center"
              direction={{ '@initial': 'column', '@bp2': 'row' }}
              justifyContent={{ '@initial': 'flex-start', '@bp2': 'space-between' }}
              gap={{ '@initial': '3', '@bp2': '6', '@bp3': '14' }}
            >
              <TextWrapper>
                <Text
                  size="headline"
                  color="primary-800"
                  weight="bold"
                  align={{ '@initial': 'center', '@bp2': 'left' }}
                  css={{ whiteSpace: 'nowrap' }}
                >
                  {t('why-we-feed-raw:healthiest-food.description-3')}
                </Text>

                <Text
                  size="headline"
                  color="primary-800"
                  align={{ '@initial': 'center', '@bp2': 'left' }}
                >
                  <Trans
                    i18nKey="why-we-feed-raw:healthiest-food.description-4"
                    components={{ link: <LinkText href="/raw-benefits" /> }}
                  />
                </Text>

                <br />
                <Text
                  size="headline"
                  color="primary-800"
                  align={{ '@initial': 'center', '@bp2': 'left' }}
                >
                  {t('why-we-feed-raw:healthiest-food.description-5')}
                </Text>
              </TextWrapper>
              <Image src={healthiest2} alt="" />
            </Stack>
          </div>
        </Stack>
      </Wrapper>
    </HealthiestFoodRoot>
  )
}

HealthiestFood.displayName = 'HealthiestFood'

export const LinkText = ({ children, href }: { href: string; children?: ReactNode }) => {
  return (
    <Link href={href} passHref>
      <Text as="a" size="headline" underline>
        {children}
      </Text>
    </Link>
  )
}
